import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import SettingStyles from '../SettingStyle.module.scss';
import { VendorUserList } from '~/components/specifics/vendors/settings/vendor_users/VendorUserList';
import { PATH } from '~/pages/vendors/settings';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: PATH },
            { label: '担当者管理' }
          ]}
        />
      </div>
      <h3 className={SettingStyles.SettingTitle}>担当者管理</h3>
      <VendorUserList />
    </VendorSettingLayout>
  </VendorLayoutV2>
);
